/**
 * Textes de l'écran « Demandes de site » : les demandes de création de site
 * que les galeries envoient depuis leur régie. Fichier à part, fusionné dans le
 * namespace `console` (D15). Voix 2.2 : phrases courtes, un verbe sur chaque bouton.
 */

export const frDemandesSite = {
  demandesSite: {
    titre: 'Demandes de site',
    texte:
      'Les galeries qui veulent un nouveau site Artosera. Prenez la demande en charge, puis marquez-la traitée.',
    chargement: 'Chargement des demandes…',
    erreurChargement: 'Impossible de lire les demandes de site.',
    vide: 'Aucune demande ne correspond à ce filtre.',
    videOuvertes: 'Aucune demande de site en attente.',
    filtres: {
      etat: 'Afficher',
      ouvertes: 'Demandes ouvertes',
      toutes: 'Toutes les demandes',
    },
    etat: {
      envoyee: 'Reçue',
      en_cours: 'En cours',
      traitee: 'Traitée',
      abandonnee: 'Abandonnée',
    },
    envoyeeLe: 'Envoyée le {{date}}',
    galerieSansNom: 'Galerie sans nom',
    resume: {
      demandeur: 'Demandeur',
      moyen: 'Contact préféré',
      langues: 'Langues',
      visite: 'Visite virtuelle',
      delai: 'Délai souhaité',
      budget: 'Budget indicatif',
    },
    sansBudget: 'Non indiqué',
    oui: 'Oui',
    non: 'Non',
    moyen: {
      email: 'E-mail',
      telephone: 'Téléphone',
      visio: 'Visioconférence',
    },
    delai: {
      des_que_possible: 'Dès que possible',
      trois_mois: 'D’ici trois mois',
      six_mois: 'D’ici six mois',
      sans_contrainte: 'Sans contrainte',
    },
    langue: {
      fr: 'Français',
      en: 'Anglais',
    },
    detail: {
      voir: 'Voir le détail',
      masquer: 'Masquer le détail',
      objectifs: 'Objectifs',
      message: 'Message',
      siteActuel: 'Site actuel',
      aucunSite: 'Aucun site',
      contact: 'Contact',
    },
    actions: {
      prendre: 'Prendre en charge',
      traiter: 'Marquer traitée',
      abandonner: 'Abandonner',
    },
    erreurs: {
      transition_interdite: 'Cette demande a déjà changé d’état. La liste vient d’être rechargée.',
      generique: 'L’opération a échoué. Réessayez.',
    },
  },
};

export const enDemandesSite = {
  demandesSite: {
    titre: 'Website requests',
    texte:
      'Galleries asking for a new Artosera website. Pick a request up, then mark it as completed.',
    chargement: 'Loading requests…',
    erreurChargement: 'Could not read the website requests.',
    vide: 'No request matches this filter.',
    videOuvertes: 'No website request is waiting.',
    filtres: {
      etat: 'Show',
      ouvertes: 'Open requests',
      toutes: 'All requests',
    },
    etat: {
      envoyee: 'Received',
      en_cours: 'In progress',
      traitee: 'Completed',
      abandonnee: 'Withdrawn',
    },
    envoyeeLe: 'Sent on {{date}}',
    galerieSansNom: 'Unnamed gallery',
    resume: {
      demandeur: 'Requested by',
      moyen: 'Preferred contact',
      langues: 'Languages',
      visite: 'Virtual tour',
      delai: 'Preferred timing',
      budget: 'Indicative budget',
    },
    sansBudget: 'Not given',
    oui: 'Yes',
    non: 'No',
    moyen: {
      email: 'Email',
      telephone: 'Phone',
      visio: 'Video call',
    },
    delai: {
      des_que_possible: 'As soon as possible',
      trois_mois: 'Within three months',
      six_mois: 'Within six months',
      sans_contrainte: 'No constraint',
    },
    langue: {
      fr: 'French',
      en: 'English',
    },
    detail: {
      voir: 'Show details',
      masquer: 'Hide details',
      objectifs: 'Goals',
      message: 'Message',
      siteActuel: 'Current website',
      aucunSite: 'No website',
      contact: 'Contact',
    },
    actions: {
      prendre: 'Pick up',
      traiter: 'Mark completed',
      abandonner: 'Withdraw',
    },
    erreurs: {
      transition_interdite: 'This request has already changed state. The list has been reloaded.',
      generique: 'The operation failed. Try again.',
    },
  },
};
